/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://app-dev.amagno.cloud/AmagnoMe/api/internal';
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
